export const GetUserSettings = 'user/settings/GET'
